var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelbarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.25C0.585786 3.25 0.25 3.58579 0.25 4C0.25 4.41421 0.585786 4.75 1 4.75H2.47076C2.87445 4.75 3.25329 4.94496 3.48793 5.27345L5 7.39035V21.9998C5 22.2881 5.16526 22.5508 5.42511 22.6757C5.68496 22.8006 5.99339 22.7655 6.21852 22.5854L13.2003 17H13.6738C14.5302 17 15.363 16.8437 16.1379 16.5521L18.1722 18.5864C18.061 18.8694 18 19.1776 18 19.5C18 20.8807 19.1193 22 20.5 22C21.8807 22 23 20.8807 23 19.5C23 18.1193 21.8807 17 20.5 17C20.1776 17 19.8694 17.061 19.5864 17.1722L17.9535 15.5393C18.7721 14.9071 19.4548 14.0903 19.9348 13.1305L22.2764 8.44721C22.6088 7.78231 22.1253 7 21.382 7H6.56453L4.70853 4.40159C4.19232 3.67891 3.35888 3.25 2.47076 3.25H1ZM6.5 17H10.7991L6.5 20.4393V17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelbarrow);
export default __webpack_public_path__ + "static/media/wheelbarrow.cedff3aaeccb92ca38dd09562ccdec28.svg";
export { ForwardRef as ReactComponent };